getEffectHandler